import React, { useEffect } from 'react';
import { Form, Formik, FormikProps } from 'formik';
import axios from 'axios';
import { useDispatch } from 'react-redux';

import { yup as yupCreator } from 'services';

import * as Actions from '../actions';
import * as Types from '../types';

interface FormValues extends Types.IForm.Appeal {}

interface IChildren extends FormikProps<FormValues> {}

interface IProps {
  applicationId: number;
  onSubmit?: () => void;
  onSuccess?: () => void;
  onError?: (error: { message: string; validations: any }) => void;
  onFinally?: () => void;
  children(props: IChildren): JSX.Element;
}

let cancelSource = axios.CancelToken.source();

const Appeal: React.FC<IProps> = ({ applicationId, onSubmit = () => {}, onSuccess = () => {}, onError = () => {}, onFinally = () => {}, children }) => {
  const dispatch = useDispatch();

  useEffect(() => () => cancelSource.cancel('canceled'), []);

  const yup = yupCreator();
  const validationSchema = (
    yup.object().shape<FormValues>({
      applicationId: yup.number().required(),
      theme: yup.string().required(),
      text: yup.string().required()
    })
  );

  const handleSubmit = (values: FormValues, { isSubmitting, setSubmitting }: FormikProps<FormValues>) => {
    if (!isSubmitting) {
      setSubmitting(true);
      cancelSource = axios.CancelToken.source();

      onSubmit();

      dispatch(Actions.Appeal.request({
        values,
        cancelSource,
        callback: {
          onSuccess,
          onError: (error) => {
            setSubmitting(false);
            onError(error);
          },
          onFinally
        }
      }));
    }
  };

  return (
    <Formik
      onSubmit={handleSubmit}
      initialValues={{
        applicationId,
        theme: '',
        text: ''
      }}
      validateOnMount
      enableReinitialize
      {...{ validationSchema }}
    >
      {(props: FormikProps<FormValues>) => (
        <Form>
          {children(props)}
        </Form>
      )}
    </Formik>
  );
};

export default Appeal;